import React, { createContext, useContext } from 'react';
import type { ProductCardProps } from './ProductCard.types';
type ProductCardContextValue = ProductCardProps;
const ProductCardContext = createContext<ProductCardContextValue | undefined>(undefined);
export const useProductCard = () => {
  const context = useContext(ProductCardContext);
  if (context === undefined) {
    throw new Error('useProductCard must be used within a ProductCardProvider');
  }
  return context;
};
interface ProductCardProviderProps {
  children: React.ReactNode;
  value: ProductCardContextValue;
}
export const ProductCardProvider = ({
  children,
  value
}: ProductCardProviderProps) => {
  return <ProductCardContext.Provider value={value} data-sentry-element="ProductCardContext.Provider" data-sentry-component="ProductCardProvider" data-sentry-source-file="ProductCardContext.tsx">{children}</ProductCardContext.Provider>;
};
export type { ProductCardContextValue };